'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { BenefitItemProps, benefitSectionBunja } from '@flipster/features/src/shared/benefit-section/state';
import { css } from '@flipster/styled-system/css';
import { hstack, stack, vstack } from '@flipster/styled-system/patterns';

import SessionNudgeButton from './SessionNudgeButton';

export const BenefitSection = () => {
  const { benefitsAtom } = useBunja(benefitSectionBunja);
  const benefits = useAtomValue(benefitsAtom);
  return (
    <section className={stack({ gap: 40 })}>
      <div className={vstack({ gap: 38 })}>
        {benefits.map((benefit) => {
          return (
            <BenefitItem
              key={benefit.id}
              iconography={benefit.iconography}
              title={benefit.title}
              description={benefit.description}
            />
          );
        })}
      </div>
      <SessionNudgeButton />
    </section>
  );
};

const BenefitItem = ({ iconography, title, description }: Omit<BenefitItemProps, 'id'>) => {
  return (
    <div className={hstack({ gap: 17, alignItems: 'flex-start', w: '100%' })}>
      <div className={css({ w: 44, h: 44, flexShrink: 0 })}>{iconography}</div>
      <div className={vstack({ gap: 8, color: 'content.default.level-5', alignItems: 'flex-start' })}>
        <h3 className={css({ textStyle: 'Title/M' })}>{title}</h3>
        <p className={css({ textStyle: 'Text/L/Regular' })}>{description}</p>
      </div>
    </div>
  );
};
